import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import OthersData from "../OthersData/OthersData";

const COPY = {
  title: "Others",
  subtitle: "You can see and edit detail about other users",
  searchPlaceholder: "Search Here",
};

const Others = () => {
  const { items, loading, searchValue, setSearchValue } = useAdminList(
    "getUsers",
    "fullName"
  );

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <OthersData driverData={items} />
    </AdminPage>
  );
};

export default Others;
